/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { SplitText } from "gsap/SplitText";
gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);

export function buildTableLoadAnimation() {

  let smoother = ScrollSmoother.create({
    smooth: 1,
    effects: true,
    // smoothTouch: 0.1,
    normalizeScroll: true
  });

  const title = document.querySelector(".buildHero__title");

  function heroSplitText() {

    // Reset if needed
    if (title.anim) {
      title.anim.progress(1).kill();
      title.split.revert();
    }

    title.split = new SplitText(title, {
      type: "lines,words",
      linesClass: "split-line",
      wordsClass: "split-word"
    });

    // Set up the anim
    title.anim = gsap.from(title.split.words, {
      scrollTrigger: {
        trigger: title,
        toggleActions: "restart pause resume reverse",
        start: "top 60%",
      },
      duration: 0.5,
      ease: "circ.out",
      y: 110,
      // rotate: 2.5,
      stagger: 0.05,
      delay: 0.3
    });

  }

  // Desktop Animation
  if (window.innerWidth > 960) {

    // Animate In
    let tl = gsap.timeline();
    tl.to('.buildHero--inner', {
      opacity: '1',
      duration: 0,
      delay: 0.25
    })
      .add(heroSplitText)
      .to('.buildHero__tagline', {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: "power3.out",
        delay: 0.5
      })
      .to('.buildHero__line', {
        scaleY: '1',
        duration: 0.5,
        delay: 0.5,
      })
      .to(smoother, {
        scrollTop: smoother.offset('.tableOptions', "top top"),
        duration: 1,
        ease: "power4.out"
      }, "-=0.35");

    ScrollTrigger.create({
      trigger: ".tableOptions",
      endTrigger: '.attachment-wrapper',
      start: "top top",
      end: "top 90%",
      pin: '.tableOptions__media',
      pinSpacing: false,
      // markers: true
    });

  }

  // Mobile Animation
  else {
    let tl = gsap.timeline();
    tl.to('.buildHero--inner', {
      opacity: '1',
      duration: 0,
      delay: 0.25
    })
      .add(heroSplitText)
      .to('.buildHero__tagline', {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: "power3.out",
        delay: 0.5
      })
      .to('.buildHero__line', {
        scaleY: '1',
        duration: 0.5,
        delay: 0.5,
      })
      .to(smoother, {
        scrollTop: smoother.offset('.tableOptions', "top 70px"),
        duration: 1,
        ease: "power4.out"
      }, "-=0.35");

    // add an automatic scroll to next section
  }


}
